import React from 'react';
import { range } from 'lodash';
import TextPlaceholder from 'components/shared/TextPlaceholder';

const HeaderPlaceholder = () => (
  <div className="JourneyContentWrapper">
    <div className="JourneyContent JourneyContent-loader">
      <div className="JourneyContent-header">
        <TextPlaceholder large />
      </div>
      <div className="JourneyContentLoader">
        <div className="JourneyContent-body">
          {range(3).map(i => (
            <TextPlaceholder key={i} />
          ))}
          <br />
          <div className="JourneyProgress" />
          <TextPlaceholder maxWidth={20} />
        </div>
        <div className="JourneyContentLoader-details">
          {range(3).map(i => (
            <TextPlaceholder key={i} maxWidth={100} minWidth={100} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default HeaderPlaceholder;
